module.exports = __webpack_public_path__ + "static/media/light_matin_logo.ae2884e8.png";